import EmailAttachment from "./EmailAttachement";

export enum ContentType {
    TEXT = "Text",
    HTML = "HTML",
}

type EmailToSendProps = {
    id: string;
    subject?: string;
    content: string;
    toRecipients: string[];
    ccRecipients: string[];
    bccRecipients: string[];
    contentType?: ContentType;
    attachments?: EmailAttachment[];
};

export default class EmailToSend {
    id: string;

    subject?: string;

    content: string;

    toRecipients: string[];

    ccRecipients: string[];

    bccRecipients: string[];

    contentType?: ContentType;

    attachments?: EmailAttachment[];

    constructor({
        id,
        subject,
        content,
        toRecipients,
        ccRecipients,
        bccRecipients,
        contentType,
        attachments,
    }: EmailToSendProps) {
        this.id = id;
        this.subject = subject;
        this.content = content;
        this.toRecipients = toRecipients;
        this.ccRecipients = ccRecipients;
        this.bccRecipients = bccRecipients;
        this.contentType = contentType;
        this.attachments = attachments;
    }
}
